import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { getCurrentIntervention } from '../../../interventions/store/selectors/interventions';
import { HttpBoxGateway } from '../../services/HttpBoxGateway';
import { BoxActions } from '../actions/box.actions';
import { getRawDevice } from '../selectors/device-detail';

@Injectable({ providedIn: 'root' })
export class SiteDetailBoxEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly boxGateway = inject(HttpBoxGateway);

    rebootBox$ = createEffect(() =>
        this.actions$.pipe(
            ofType(BoxActions.boxRebootRequested),
            switchMap(({ deviceId }) =>
                combineLatest([
                    this.store.select(getRawDevice(deviceId)),
                    this.store.select(getCurrentIntervention),
                ]).pipe(
                    take(1),
                    map(([device, intervention]) => ({ device, sessionId: intervention.sessionId })),
                ),
            ),
            switchMap((command) =>
                this.boxGateway
                    .reboot(command)
                    .pipe(map((pendingTask) => BoxActions.boxRebootStarted({ command, pendingTask }))),
            ),
        ),
    );
}
